import { render, staticRenderFns } from "./HeatedDiscussion3.vue?vue&type=template&id=25787f0e&scoped=true&lang=html"
import script from "./HeatedDiscussion3.vue?vue&type=script&lang=js"
export * from "./HeatedDiscussion3.vue?vue&type=script&lang=js"
import style0 from "./HeatedDiscussion3.vue?vue&type=style&index=0&id=25787f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25787f0e",
  null
  
)

export default component.exports